export function isChangeNumber(value) {
  if (!value) return false
  if(typeof value === 'number' && isFinite(value)) return true
  return !value.match(/[^0-9]/)
}

export function isString(value){
  return typeof value === 'string'
}

export function convertHalf(value) {
  return value.replace(/[０-９]/g, (s) => {
    return String.fromCharCode(s.charCodeAt(0) - 65248)
  })
}